import { getActionType } from './util';

const initialState = {
  scopeContext: {},
  reports: [],

  // common filter for report modal
  filters: {},
  activeCaseloads: [],
  studentCount: undefined,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case getActionType('populateScopeContext'):
      return {
        ...state,
        scopeContext: action.data,
      };

    case getActionType('populateReports'):
      return {
        ...state,
        reports: action.data,
      };

    case getActionType('setFilter'):
      return {
        ...state,
        filters: action.filters,
      };

    case getActionType('populateStudentCount'):
      return {
        ...state,
        studentCount: action.studentCount,
      };

    case getActionType('populateActiveCaseloads'):
      return {
        ...state,
        activeCaseloads: action.activeCaseloads,
      };
    case getActionType('populateReportDetails'):
      return {
        ...state,
        reportDetails: action.data,
      };
    case getActionType('clearReportDetails'):
      return { ...state, reportDetails: null };
    default:
      return state;
  }
};
